<template>
  <div class="steps-content">
    <div class="step" v-for="(callToAction, i) in callToActions" :key="callToAction.id">
      <img :src="getIconUrl(callToAction.icon.url)" alt="Create an Account" :title="callToAction.title">
      <h3 v-if="!pageName">{{callToAction.title}}</h3>
      <p class="mt-3"><strong v-if="pageName">Step {{ i + 1 }}:</strong> {{callToAction.description}}</p>
    </div>
  </div>
</template>

<script>

export default {
  name: 'SimpleSteps',
  props: ['callToActions', 'pageName'],
  data() {
    return {
      getPathFromMedia: process.env.VUE_APP_CMS_BASE_URL ?? 'https://cms.edurent.com',
    }
  },
  methods: {
    getIconUrl(url = '') {
      return this.getPathFromMedia + url;
    },
  },
}
</script>

<style>
.steps-content {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 85px;
}
 .steps-content .step {
   position: relative;
   flex: 0 1 32%;
   display: inline-block;
   text-align: center;
   padding: 0;
 }

 .steps-content img {
   width: 150px;
   height: 150px;
   position: relative;
   left: -3px;
 }

 .steps-content h3 {
   width: 100%;
   font-size: 20px;
   font-weight: 700;
   color: #2D76E3;
   margin: 16px 0 28px 0;
 }

 .steps-content .step:nth-child(2) h3 {
   margin-top: 18px;
 }

 .steps-content p {
   max-width: 445px;
   margin: 0 auto;
   line-height: 1.6;
   color: #000;

 }

 .steps-content .step:not(:nth-child(3))::after {
   content: "";
   position: absolute;

   right: -33px;
   top: 36px;

   width: 25px;
   height: 35px;

   background-image: url('../../src/assets/icons/chevron-right.png');
   background-size: contain;
   background-repeat: no-repeat;
 }

 @media (max-width: 980px) {

   .simple-steps h2 {
     font-size: 26px;
   }

   .steps-content .step {
     flex: 0 1 100%;
     margin-bottom: 80px;
   }

   .steps-content .step:last-child {
     margin-bottom: 5%;
   }

   .steps-content .step:not(:nth-child(3))::after {
     top: 115%;
     right: calc(50% - 12.5px);
     transform: rotate(90deg);
   }
    @media (max-width: 768px) {
      .simple-steps .step {
        margin-bottom: 110px;
      }

    }
 }
</style>